export const IconDownload = ({ size = 16 }: { size?: number }) => {
  return (
    <svg fill="none" height={size} viewBox="0 0 16 16" width={size} xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_153_7485)">
        <path
          d="M15 10.3333V11.2667C15 12.5735 15 13.2269 14.7457 13.726C14.522 14.165 14.165 14.522 13.726 14.7457C13.2269 15 12.5735 15 11.2667 15H4.73333C3.42654 15 2.77315 15 2.27402 14.7457C1.83498 14.522 1.47802 14.165 1.25432 13.726C1 13.2269 1 12.5735 1 11.2667V10.3333M11.8889 6.44444L8 10.3333M8 10.3333L4.11111 6.44444M8 10.3333V1"
          stroke="black"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
      </g>
      <defs>
        <clipPath id="clip0_153_7485">
          <rect fill="white" height="16" width="16" />
        </clipPath>
      </defs>
    </svg>
  );
};
